import { IconCirclePlusOutline18 as PlusCircleIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const tableAddRowCommand: SlashCommandDefinition = {
	key: "table-add-row",
	title: "Add Row to Table",
	icon: <PlusCircleIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).addRowAfter().run()
	},
	group: "table",
}
